import { useRef, useEffect } from 'react';

import { Box } from '@simplywallst/ui-core';

import { paintSnowflakeToCanvas } from '../../utils';

export interface Props {
  styleType?: 'light' | 'dark';
  valueScores: number;
  futureScores: number;
  pastScores: number;
  healthScores: number;
  dividendScores: number;
  width?: number;
  blobFillStyle?: string;
  blobStrokeStyle?: string;
}

export const Canvas = ({
  styleType = 'dark',
  valueScores,
  futureScores,
  pastScores,
  healthScores,
  dividendScores,
  width = 280,
  blobFillStyle,
  blobStrokeStyle,
}: Props) => {
  const canvas = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    try {
      if (canvas.current === null) return;

      const ctx = canvas && canvas.current.getContext('2d');
      if (ctx === null) return;

      paintSnowflakeToCanvas({
        ctx,
        points: [
          valueScores,
          futureScores,
          pastScores,
          healthScores,
          dividendScores,
        ],
        styleType,
        blobFillStyle,
        blobStrokeStyle,
      });
    } catch (error) {
      console.error(error);
    }
  }, [
    width,
    blobFillStyle,
    blobStrokeStyle,
    styleType,
    valueScores,
    futureScores,
    pastScores,
    healthScores,
    dividendScores,
  ]);

  return (
    <Box position="absolute" top="0" left="0">
      <canvas
        ref={canvas}
        width={width * 2}
        height={width * 2}
        style={{
          width: '100%',
        }}
      />
    </Box>
  );
};
